window.addEventListener('DOMContentLoaded', () => {
	const contact = document.querySelectorAll('.contact');

	contact.forEach(section => {
		const form = section.querySelector('.contact__col--form form'),
			  selectParent = section.querySelector('.field__item--select'),
			  select = form.querySelector('select');

		let selectedValue = select.options[select.selectedIndex].value;

		if (selectedValue != "") {
			selectParent.classList.add('selected');
		} else {
			selectParent.classList.remove('selected');
		}

		select.addEventListener('change', () => {
			selectedValue = select.options[select.selectedIndex].value;

			if (selectedValue != "") {
				selectParent.classList.add('selected');
			} else {
				selectParent.classList.remove('selected');
			}
		});
	});
})